module.exports = __webpack_public_path__ + "static/img/3_9_1.8ee2111e.jpg";